import { useState } from 'react';

type ModalState = {
  [key: string]: boolean;
};

type ModalActions = {
  [key: string]: () => void;
};

const useModals = (
  initialModals: ModalState,
  modalActions: ModalActions = {}
) => {
  const [modals, setModals] = useState<ModalState>(initialModals);

  const openModal = (modalName: string) => {
    setModals((prev) => ({
      ...prev,
      [modalName]: true
    }));
  };

  const closeModal = (modalName: string) => {
    setModals((prev) => ({
      ...prev,
      [modalName]: false
    }));
  };

  const actionModal = (modalName: string) => {
    setModals((prev) => ({
      ...prev,
      [modalName]: !prev[modalName]
    }));
    if (modalActions[modalName]) {
      modalActions[modalName]();
    }
  };

  return {
    modals,
    openModal,
    closeModal,
    actionModal
  };
};

export default useModals;
